import React, { useContext } from 'react';
import styled from 'styled-components';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  useTheme,
  Grid,
  Icon
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LaptopWindowsIcon from '@material-ui/icons/LaptopWindows';
import AppleIcon from '@material-ui/icons/Apple';
import { Button } from '../ui/forms/Button';
import { DatabaseContext } from '../../contexts/DatabaseContext';

export const ZipFileHelp = ({ open, close }) => {
  const { palette } = useTheme();
  const { apiUrl } = useContext(DatabaseContext);
  return (
    <Dialog open={open} onClose={close} maxWidth='md'>
      <DialogTitle>ZIP File How-To</DialogTitle>
      <DialogContent>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <Typography variant='button'>
             
              <LaptopWindowsIcon style={IStyle}/> 
              Windows
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <DialogContentText>
                  For Windows, select all of the files you want to upload,
                  right-click and select{' '}
                  <Mono>Send To - Compressed (zipped) folder</Mono> Use the
                  .zip this creates to upload the photos to IDCapture.
                  <Notes>
                    <NotesLabel variant='subtitle2'>Notes</NotesLabel>
                    <Note>
                      The .zip file will be named the same as the file you
                      right-clicked to create the zip.
                    </Note>
                    <Note>
                      <Mono background={palette.background.paper}>Ctrl+A</Mono>{' '}
                      will select all files in a folder
                    </Note>
                  </Notes>
                </DialogContentText>
              </Grid>
              <Grid item xs={12} md={6}>
                <img
                  src={`${apiUrl}/assets/zip-instructions-windows.jpg`}
                  alt='Windows Instruction Screenshot'
                  style={{
                    maxWidth: '100%',
                    marginTop: '-1rem',
                    borderRadius: '0.5rem',
                  }}
                />
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <Typography variant='button'>
              
              <AppleIcon style={IStyle}/>
              macOS
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <DialogContentText>
              For macOS, simply select all of the files you want to upload,
              right-click and choose <Mono>Compress Items</Mono>
              <Notes>
                <NotesLabel variant='subtitle2'>Notes</NotesLabel>
                <Note>The .zip file will be named Archive.zip</Note>
                <Note>
                  <Mono background={palette.background.paper}>Cmd⌘+A</Mono> will
                  select all files in a folder
                </Note>
              </Notes>
            </DialogContentText>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </DialogContent>
      <DialogActions>
        <Button colour='info' onClick={close}>
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const IStyle ={
  fontSize:'13px',
  marginRight:'5px'
}

const Notes = styled.div`
  border-top: 1px solid;
  margin-top: 2rem;
  padding: 0.5rem 1rem;
`;
const Note = styled.li`
  font-size: 1.4rem;
  margin: 0.5rem 0 0 0.5rem;
`;
const NotesLabel = styled(Typography)`
  font-weight: 700;
  text-transform: uppercase;
`;

const Mono = styled.span`
  font-family: monospace;
  font-size: 2rem;
  padding: 0.3rem 0.5rem;
  background: ${(props) => props.background};
`;
